export default __webpack_public_path__ + "static/media/icon-work.a3f124e5.svg";